import { getCanonicalSlug, productLink } from '@components/config/helpers';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from "next/link"
import { useTheme } from '@mui/material/styles';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';

const CategoryProductPriceLabels = (props) => {
    const { getSetting } = useGlobalSettings();
    const {
        product_name,
        section_slug,
        canonical_category_slug,
        product_slug,
        long_term,
        package_core
    } = props;

    const urlLink = getCanonicalSlug({ canonical_category_slug, section_slug });

    const theme = useTheme();
    const colour = getSetting('product_title_colour', theme.palette.primary.main);
    const fontSize = getSetting('product_title_size', '16px');
    const weight = getSetting('product_title_weight', '400');

    return (
        <Box sx={{ minHeight: '72px' }} className="mt-3">
            <Link shallow={true} className={` category_anchor ${package_core ? 'pointerEvent' : ''}`} href={productLink(urlLink, product_slug, long_term)}>
                <Typography variant="h6" component="div" className="transition-hover" sx={{ minHeight: 55, color: colour, fontWeight: weight, fontSize: fontSize, ':hover': { color: 'primary.dark' } }} >
                    {product_name}
                </Typography>
            </Link>
        </Box>
    )
}

export default CategoryProductPriceLabels